export const notifyContents = {
  newConnectSuccess : "You connect to the database successfully.",
  newConnectFail: "You can't connect to the database.",
  databaseSelectSuccess: "Database selected successfully",
  databaseSelectFail: "Database select failed",
  runQuerySuccess : "Query run successfully.",
  runQueryFail : "Query run failed.",
  databaseSave: "Database saved successfully.",
  databaseDelete: "Database deleted successfully.",
  exportSuccess: "Result exported successfully.",
  queryCreateSuccess: "Query created successfully.",
  queryDeleteSuccess: "Query deleted successfully.",
  addTableDataSuccess: "Table added successfully.",
  createViewSuccess: "View created successfully",
  resetSuccess: "Table reset successfully",
  unionWarning: "Select queries to run union"
}